import { render } from "./ProposalSubmissionPage.vue?vue&type=template&id=096b5897&scoped=true"
import script from "./ProposalSubmissionPage.vue?vue&type=script&lang=js"
export * from "./ProposalSubmissionPage.vue?vue&type=script&lang=js"

import "./ProposalSubmissionPage.vue?vue&type=style&index=0&id=096b5897&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096b5897"]])

export default __exports__